import Studio, { IStudio, IStudioApiModel } from '@models/Studio.model';

export interface IOrganization {
  id: string;
  name: string;
  displayName: string;
  logo?: string;
  metadata: any;
  studio?: IStudio;
}

export interface IOrganizationApiModel {
  id: string;
  name: string;
  display_name: string;
  branding?: {
    logo_url?: string;
  };
  metadata: any;
  studio?: IStudioApiModel;
}

export default class Organization implements IOrganization {
  public readonly id: string;

  public readonly name: string;

  public readonly displayName: string;

  public readonly logo?: string;

  public readonly colors?: any;

  public readonly metadata: any;

  public readonly studio?: IStudio;

  constructor(
    id: string,
    name: string,
    displayName: string,
    metadata: any,
    logo?: string,
    studio?: IStudio,
  ) {
    this.id = id;
    this.name = name;
    this.displayName = displayName;
    this.metadata = metadata;
    this.logo = logo;
    this.studio = studio;
  }

  static fromApiModel(apiModel: IOrganizationApiModel) {
    const { id, name, display_name: displayName, metadata } = apiModel;
    const studio = apiModel.studio
      ? Studio.fromApiModel(apiModel.studio)
      : undefined;
    const logo = apiModel.branding?.logo_url;

    return new Organization(id, name, displayName, metadata, logo, studio);
  }
}
